import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [pendingEmail, setPendingEmail] = useState(null);

  // Set axios defaults
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Load user on mount
  useEffect(() => {
    const loadUser = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await axios.get(`${API_BASE_URL}/auth/me`);
        setUser(data.user);
      } catch {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    loadUser();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API_BASE_URL}/auth/login`, { email, password });
    if (data.requiresVerification) {
      setPendingEmail(data.email);
      return data;
    }
    localStorage.setItem('token', data.token);
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const register = async (userData) => {
    const { data } = await axios.post(`${API_BASE_URL}/auth/register`, userData);
    if (data.requiresVerification) {
      setPendingEmail(data.email);
    }
    return data;
  };

  const verifyOtp = async (email, otp) => {
    const { data } = await axios.post(`${API_BASE_URL}/auth/verify-otp`, { email, otp });
    localStorage.setItem('token', data.token);
    setToken(data.token);
    setUser(data.user);
    setPendingEmail(null);
    return data;
  };

  const resendOtp = async (email) => {
    const { data } = await axios.post(`${API_BASE_URL}/auth/resend-otp`, { email });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    setPendingEmail(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, pendingEmail, login, register, verifyOtp, resendOtp, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
